import Client from "./client";

// The full permission catalog (key/label/group) - lets the Roles UI render
// its checkboxes without hardcoding the list (see api/lib/permissions.js).
export const GetPermissionCatalog = ({accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/permissions', {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.permissions);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// The 4 global template roles - what a ProjectMember created outside any
// organization (direct invite or code join) draws its role from.
export const GetGlobalRoles = ({accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/roles/global', {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.roles);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetOrganizationRoles = ({organizationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/organizations/${organizationId}/roles`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.roles);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateOrganizationRole = ({organizationId, name, permissions, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/organizations/${organizationId}/roles`, {name, permissions}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.role);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const UpdateOrganizationRole = ({organizationId, roleId, name, permissions, accessToken}) => {
    const data = {};
    if (name !== undefined) data.name = name;
    if (permissions !== undefined) data.permissions = permissions;

    return new Promise((resolve, reject) => {
        Client.put(`/api/organizations/${organizationId}/roles/${roleId}`, data, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.role);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteOrganizationRole = ({organizationId, roleId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/organizations/${organizationId}/roles/${roleId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
